export default __webpack_public_path__ + "static/media/User-manaement2.769ef3d0.svg";